import React from "react";
import { Field } from "react-final-form";

const SelectFormField = ({
  options,
  disabled,
  fieldName,
  name,
  label,
  placeholder,
  validate,
  classes,
  defaultValue = "",
  handleSelect,
}) => {
  let optionsMarkup;

  if (options && typeof options[0] === "string") {
    optionsMarkup = options.map((item, index) => {
      return (
        <option key={index} value={item}>
          {item}
        </option>
      );
    });
  } else {
    optionsMarkup = options;
  }

  return (
    <Field
      fieldName={fieldName}
      name={name}
      label={label}
      allowNull={false}
      validate={validate}
      defaultValue={defaultValue}
      handleSelect={handleSelect}>
      {({
        input: { name, value, onChange, ...inputRest },
        meta: { touched, error, ...metaRest },
        label,
        handleSelect,
        fieldName,
        defaultValue,
        ...props
      }) => (
        <div
          className={`${
            touched && error ? "form-group has-feeback has-error" : "form-group"
          } ${classes}`}>
          <label htmlFor={name} className="required-field">
            {label}
          </label>
          <select
            className="form-control"
            name={`event_register_form[${name}]`}
            id={`event_register_form_${name}`}
            disabled={disabled}
            defaultValue={defaultValue}
            onChange={(e) => {
              onChange(e);
              handleSelect(fieldName, e);
            }}
            {...inputRest}>
            {optionsMarkup}
          </select>
          {touched && error && <span className="donation-error">{error}</span>}
        </div>
      )}
    </Field>
  );
};

export default SelectFormField;
